import React from "react";
import { CardSubtitle, CardTitle, Label } from "reactstrap"

const UploadDesc = ({
  label = "Dropzone",
  description = "description",
  upload = "",
  typeUpload = "",
  widthSize = 0,
  heightSize = 0,
  required = false,
  addClass = 'mb-3'
}) => {

  if (upload == "Image") {
    description = 'File type png, jpg, jpeg only, Max filesize 10 MB'
  }
  if (upload == "Video") {
    description = 'File type mp4 only, Max file size 50 MB'
  }
  if (upload == "ImageVideo") {
    description = 'File type png, jpg, jpeg and mp4 only, Max file size 50 MB'
  }
  if (typeUpload == "ImageMap") {  
    description = `File type png, jpg, jpeg only, Max filesize 10 MB`
    if (widthSize) {
      description += `, File resolution `
      description += `${widthSize} x `
    }
    if (heightSize) {
      description += `${heightSize}`
    }
  }
  if (typeUpload == "ImageVideoMap") {  
    description = `File type png, jpg, jpeg and mp4 only, Max filesize 50 MB`
    if (widthSize) {
      description += `, File resolution `
      description += `${widthSize} x `
    }
    if (heightSize) {
      description += `${heightSize}`
    }
  }
  if (upload == "PDF") {
    // acceptFile = { 'application/pdf': ['.pdf'] }
    description = 'File type pdf only, Max file size 50 MB'
  }

  return (
    <div className={` ${addClass}`}>
      <div className="">
        <Label
          htmlFor=""
          className="col-md-12 col-form-label form-label"
        >
          {label} {required ? <span className="t-require">*</span> : <></> }
        </Label>
      </div>
      <CardSubtitle className="">
        {description}
      </CardSubtitle>
    </div>
  )
}

export default UploadDesc
